/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Injectable } from "@angular/core";
import { EventBusService, Logger, BusEvent } from "@html-core";

@Injectable({
   providedIn: "root"
})
export class LoginModel {
   public isLoginInitialized: boolean = false;
   public certAuth: boolean = false;
   constructor(eventBusService: EventBusService) {
      Logger.info("init isLoginInitialized as false");
      eventBusService.listen(BusEvent.CertAuth.MSG_TYPE).subscribe((msg: BusEvent.CertAuth) => {
         this.certAuth = msg.enable;
      });
   }
}
